import React, { useState } from 'react';
import ImageLightbox from '../components/ImageLightbox';
import '../styles/about.css';

const AboutPage = () => {
  const [lightboxIndex, setLightboxIndex] = useState(null);

  const clubImages = [
    {
      url: 'https://customer-assets.emergentagent.com/job_instructor-bios/artifacts/pznto3d3_188657176_4526064760756250_5059620663382267491_n.jpg',
      alt: 'Karate training session in the dojo'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_instructor-bios/artifacts/15j8lcr8_480631436_9945022262193779_7408478139287180151_n.jpg',
      alt: 'Karate demonstration with flying kick'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_instructor-bios/artifacts/pbx1bxfr_516840258_10162664268310469_5170304700623412253_n.jpg',
      alt: 'Outdoor training session'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_instructor-bios/artifacts/8qgh9rbg_518338915_10162664268985469_642790059381780905_n.jpg',
      alt: 'Group photo with club banners'
    }
  ];

  const handleNext = () => {
    setLightboxIndex((prev) => (prev + 1) % clubImages.length);
  };

  const handlePrev = () => {
    setLightboxIndex((prev) => (prev - 1 + clubImages.length) % clubImages.length);
  };

  return (
    <div className="page-wrapper about-page">
      <div className="page-header">
        <div className="container">
          <h1 className="page-title">About San Kai Karate Association</h1>
          <p className="page-subtitle">
            Established in 1988 - Over 35 years of excellence in martial arts
          </p>
        </div>
      </div>

      <div className="container">
        <div className="about-content">
          {/* Story Section */}
          <div className="about-story-section">
            <div className="story-content">
              <p className="story-paragraph">
                San Kai Karate Association was founded in 1988 by Paul Rees, a 6th Dan Black Belt, with the blessing of his former Sensei, Lee Crown (5th Dan). From the very beginning, the club has been dedicated to providing high-quality martial arts tuition, combining the traditional Japanese style Wado-Ryu with a variety of complementary styles to ensure the highest standards of training.
              </p>
              
              <p className="story-paragraph">
                Over the years, San Kai has welcomed men, women, and children aged 5 and above, promoting not only physical skills but also the development of self-confidence, discipline, fitness, etiquette, speed, power, and technique. The club maintains a friendly, family-oriented atmosphere, fostering good relations among students, their families, and friends.
              </p>
              
              <p className="story-paragraph">
                Our instructors are all experienced, NVQ-qualified coaches with first aid knowledge and/or certification. Many of them have over 30 years of training and teaching experience, which is more than most clubs in the Essex area. We pride ourselves on maintaining the original qualities of traditional karate, keeping an eight-grade system to black belt, and offering fair, competitive fees while delivering outstanding tuition.
              </p>
              
              <p className="story-paragraph">
                In its early years, Paul had the privilege of meeting and training alongside respected martial artists such as Vic Charles MBE and Kevin "The Jedi" Brewton, and even took part in the Sport Aid demonstration team in 1988, meeting well-known figures like the Pet Shop Boys and Bob Geldof.
              </p>
              
              <p className="story-paragraph highlight">
                Over the last decades, San Kai has become recognized across Britain for its high standards and commitment to both traditional and modern karate. We hope this gives you a glimpse into our world and inspires you to explore what we have to offer.
              </p>
            </div>
          </div>

          {/* Image Gallery Section */}
          <div className="about-gallery-section">
            <h2 className="gallery-title">Our Dojo in Action</h2>
            <div className="about-image-grid">
              {clubImages.map((image, index) => (
                <div 
                  key={index} 
                  className="about-image-card"
                  onClick={() => setLightboxIndex(index)}
                  role="button"
                  tabIndex={0}
                  onKeyPress={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      setLightboxIndex(index);
                    }
                  }}
                >
                  <div className="image-wrapper">
                    <img src={image.url} alt={image.alt} />
                    <div className="image-overlay">
                      <span className="image-overlay-text">Click to view</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Lightbox */}
          {lightboxIndex !== null && (
            <ImageLightbox
              images={clubImages}
              currentIndex={lightboxIndex}
              onClose={() => setLightboxIndex(null)}
              onNext={handleNext}
              onPrev={handlePrev}
            />
          )}

          {/* Values Section */}
          <div className="values-section">
            <h2 className="values-title">What We Stand For</h2>
            <div className="values-grid">
              <div className="value-card">
                <div className="value-icon">🥋</div>
                <h3>Traditional Excellence</h3>
                <p>Maintaining authentic Wado-Ryu traditions while embracing modern training methods</p>
              </div>
              <div className="value-card">
                <div className="value-icon">👨‍👩‍👧‍👦</div>
                <h3>Family Atmosphere</h3>
                <p>A welcoming environment for students of all ages, from 5 years old to adults</p>
              </div>
              <div className="value-card">
                <div className="value-icon">🏆</div>
                <h3>Expert Instruction</h3>
                <p>NVQ-qualified coaches with over 30 years of experience and first aid certification</p>
              </div>
              <div className="value-card">
                <div className="value-icon">💪</div>
                <h3>Holistic Development</h3>
                <p>Building confidence, discipline, fitness, and character alongside martial arts skills</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
